import { motion } from "framer-motion";

export default function ProgressBar({ progress = 0 }: { progress?: number }) {
  return (
    <div className="w-full h-[6px] bg-white/20 rounded-4 mt-2">
      <motion.div
        initial={{ backgroundPosition: "0 0", width: "0%" }}
        animate={{
          backgroundPositionX: ["0px", "600px"],
          width: `${progress}%`,
        }}
        transition={{
          width: { type: "tween" },
          backgroundPositionX: {
            duration: 6,
            ease: "linear",
            repeat: Infinity,
            repeatType: "loop",
          },
        }}
        style={{
          backgroundImage: `linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)`,
          backgroundSize: "600px 100%",
        }}
        className="h-full bg-tangerine rounded-4"
      />
    </div>
  );
}
